/*
var LANGUAGES = {
    en: {
        Username: 'User Name'
    },
    CURR_LANGUAGE: 'en'
};
*/
/*for LANGUAGES hint*/
if(Object.keys(LANGUAGES).length === 0) {
    console.error('Please clone the project: EonOneWorkflowRegex to generate LANGUAGES files');
}

(function() {
    var app = angular.module('gs-login');
    function fmtDirective($timeout) {
        return {
            restrict: 'E',
            scope: {
            },
            link: function(scope, element, attr) {
                function updateText() {
                    var text = FMT(attr.key);
                    element.text(text);
                }
                updateText();
            }
        };
    };
    fmtDirective.$inject = ['$timeout'];
    app.directive('fmt', fmtDirective);
})();
